





























import Vue, { PropOptions } from 'vue';
import { ChartData } from 'chart.js';

export default Vue.extend({
  name: 'RankingPanel',
  props: {
    chartData: Object as PropOptions<ChartData>,
    // dataを表示用に変換する関数。（秒から時間文字列に変換するなど）
    dataConverter: {
      type: Function,
      default: (data) => data,
    },
  },
  computed: {
  },
  data() {
    return {
      itemDatas: [] as number[],
      itemLabels: [] as string[],
      itemBarColors: [] as string[],
      itemBarWidthList: [] as string[],
      isExpanded: false,
    };
  },
  mounted() {
    this.updateChartDatas();
  },
  methods: {
    updateItemDatas() {
      if ( this.chartData && this.chartData.datasets && this.chartData.datasets[0].data && this.chartData.datasets[0].data.length > 0) {
        this.itemDatas = this.chartData.datasets[0].data as number[];
      }
    },
    updateItemLabels() {
      if ( this.chartData && this.chartData.labels ) {
        this.itemLabels = this.chartData.labels as string[];
      }
    },
    showMore() {
      this.isExpanded = true;
      this.$emit('showMore');
    },
    getItemBarColor(i: number) {
      return this.itemBarColors[i] !== undefined ? this.itemBarColors[i] : this.itemBarColors[this.itemBarColors.length - 1];
    },
    getItemBarWidth(i: number) {
      return this.itemBarWidthList[i] !== undefined ? this.itemBarWidthList[i] : this.itemBarWidthList[this.itemBarWidthList.length - 1];
    },
    updateItemBarColors() {
      if ( this.chartData && this.chartData.datasets && this.chartData.datasets[0].backgroundColor ) {
        this.itemBarColors = this.chartData.datasets[0].backgroundColor as string[];
      }
    },
    updateItemBarWidthList() {
      // console.log("chartData="+JSON.stringify(this.chartData));
      if ( this.chartData && this.chartData.datasets && this.chartData.datasets[0].data ) {
        const itemDatas = this.chartData.datasets[0].data as number[];
        // console.log("itemDatas="+JSON.stringify(itemDatas));
        if ( itemDatas.length > 0 ) {
          // バーの幅算出
          const maxData = itemDatas[0] as number; // 最初の値を最大値とみなす。
          this.itemBarWidthList = [];
          for ( const [i, itemData] of itemDatas.entries() ) {
            // console.log(`itemData[${i}]=${itemData}`);
            this.itemBarWidthList.push( maxData <= 0 ? '0%' : `${Math.floor(itemData * 100 / maxData)}%` );
          }
          // console.log("itemBarWidthList="+JSON.stringify(this.itemBarWidthList));
        }
      }
    },
    updateChartDatas() {
      this.updateItemDatas();
      this.updateItemLabels();
      this.updateItemBarWidthList();
      this.updateItemBarColors();
    },
  },
});
